import content from "./jsonParsers/content.json";

const ResultSet = {
  supertitle: content.Results.supertitle,
  title: content.Results.title,
  subtitle: content.Results.subtitle,
  titleG: content.Results.titleG,
  titleB: content.Results.titleB,
  titleG: content.Results.titleM,
  btn1: content.Results.btn1,
  btn2: content.Results.btn2,
  legend1: content.Results.legend1,
  legend2: content.Results.legend2,
  report: content.Results.report,
  footer1: content.Results.footer1,
  footer2: content.Results.footer2,
  copyright: content.Results.copyright,
  footerLink1: content.Results.footerLink1,
  footerLink2: content.Results.footerLink2,
  copied: content.Results.copied,
};

export default ResultSet;
